angular.module('SpidApp')

.constant('OrderAdapterConfig', {
  name : 'Order',
  fields : [
    {
      local   : 'id',
      distant : 'id'
    }, {
      local   : 'updated_at',
      distant : 'updated_at'
    }, {
      local   : 'agency_id',
      distant : 'agency_id'
    }, {
      local   : 'lot',
      distant : 'lot'
    }
  ]
})